import React, { useState, forwardRef } from "react";
import { Label } from "@americanexpress/dls-react";
import FormField from "../Common/FormField";
import AuthorizedSignatoryNameFields from "./AuthorizedSignatoryNameFields";
import AuthorizedSignatoryPosition from "./AuthorizedSignatoryPosition";
import {
  SWEDEN_NORWAY, AUTHORIZED_POSITIONS,
  AUTH_SIGNATORY_VALIDATION_FIELDS,
} from "../Common/constants";
import { isLanguageEnglish } from "../Common/utils";

const AuthorizedSignatoryForm = forwardRef(({
  t,
  language,
  userDataUser,
  index,
  fullName,
  nameObj,
  authSaveObj,
  submit,
}, ref) => {
  const [authErrors, setAuthErrors] = useState({
    fName: false,
    lName: false,
    position: false,
    emailId: false,
    phoneNumber: false,
  });

  const authorizedSignatoryForm = userDataUser?.authorizedSignatories?.[index] || {};
  const authorPositions = isLanguageEnglish(language) ? AUTHORIZED_POSITIONS.EN : AUTHORIZED_POSITIONS.OTHER;

  const handleChange = (field, value) => {
    const isError = field === "position"
      ? AUTH_SIGNATORY_VALIDATION_FIELDS.position(value)
      : !(value?.length > 0 && value.match(AUTH_SIGNATORY_VALIDATION_FIELDS[field]));
    setAuthErrors((prev) => ({ ...prev, [field]: isError }));
    authSaveObj(field, value);
  };

  const handleNameChange = (fieldKey, value) => {
    const isError = !(value?.length > 0 && value.match(AUTH_SIGNATORY_VALIDATION_FIELDS[fieldKey]));
    setAuthErrors((prev) => ({ ...prev, [fieldKey]: isError }));
    nameObj(fieldKey, value);
  };

  return (
    <>
      {SWEDEN_NORWAY.includes(userDataUser.country) && (
        <div className="col-12 pad-2-tb">
          <Label>{`${t("access.approver")} - ${index + 1} :`}</Label>
        </div>
      )}

      <div className="row">
        <AuthorizedSignatoryNameFields
          t={t}
          language={language}
          fullName={fullName}
          submit={submit}
          authErrors={authErrors}
          handleNameChange={handleNameChange}
        />
      </div>

      <div className="row">
        <AuthorizedSignatoryPosition
          t={t}
          authorPositions={authorPositions}
          value={authorizedSignatoryForm?.position}
          onChange={handleChange}
          authErrors={authErrors}
          submit={submit}
        />
      </div>

      <div className="row">
        <FormField
          id="authEmail"
          name="authEmail"
          label={t("common.EmailAddress")}
          colmd="col-md-12"
          value={authorizedSignatoryForm?.emailId || ""}
          onBlur={(event) => { handleChange("emailId", event.target.value) }}
          onChange={(event) => { handleChange("emailId", event.target.value) }}
          error={authErrors.emailId ? t("newuser.workemailerror") : submit && !authorizedSignatoryForm.emailId && t("newuser.emailrequired")}
        />
      </div>

      <div className="row">
        <FormField
          id="authPhone"
          name="authPhone"
          label={t("common.TelephoneNumber")}
          colmd="col-md-12"
          value={authorizedSignatoryForm?.phoneNumber || ""}
          onBlur={(event) => { handleChange("phoneNumber", event.target.value) }}
          onChange={(event) => { handleChange("phoneNumber", event.target.value) }}
          hint={t("common.TelephoneInfoMessage")}
          error={authErrors.phoneNumber ? t("newuser.phnerror") : submit && !authorizedSignatoryForm.phoneNumber && t("newuser.phnrequired")}
        />
      </div>
    </>
  );
});

export default AuthorizedSignatoryForm;
